import { SupportedLocale, getLetterDateTime } from "util/dates";

import { Stage } from "../typings/Stage";

type SiteWithTitle = {
  title?: string | null;
};

const getName = (stages: Stage[] | null, sites: SiteWithTitle[]): string => {
  if (stages && stages.length === 1 && stages[0].name) {
    return stages[0].name;
  }

  if (sites.length === 1 && sites[0]?.title) {
    return sites[0].title.split(",")[0].trim();
  }

  if (stages && stages.length > 1) {
    return "Multiple Stages";
  }

  if (sites.length > 1) {
    return "Multiple Sites";
  }

  return "Unknown Stage";
};

export const generateTitle = (stages: Stage[] | null, sites: SiteWithTitle[], locale: SupportedLocale): string => {
  const dateString = getLetterDateTime({ locale });
  const name = getName(stages, sites);

  return `${name} - ${dateString}`;
};
